"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Edit2, X } from "lucide-react";
import type { ListItemRowProps } from "./types";

/**
 * Renders a single list item row with view mode (label + edit/remove buttons)
 * or edit mode (inline input with save/cancel).
 */
export function ListItemRow({
  item,
  index,
  isEditing,
  editingValue,
  placeholder,
  onStartEdit,
  onRemove,
  onSaveEdit,
  onCancelEdit,
  onEditingValueChange,
  onKeyDown,
}: ListItemRowProps) {
  return (
    <div className="flex items-center gap-2 p-2 bg-muted rounded-md border border-input">
      {isEditing ? (
        <>
          <Input
            value={editingValue}
            onChange={(e) => onEditingValueChange(e.target.value)}
            onKeyDown={onKeyDown}
            placeholder={placeholder}
            className="flex-1 h-10 sm:h-8"
            autoFocus
          />
          <Button
            size="sm"
            variant="ghost"
            className="h-10 w-10 sm:h-8 sm:w-8 p-0 flex-shrink-0"
            onClick={onSaveEdit}
            title="Save"
          >
            ✓
          </Button>
          <Button
            size="sm"
            variant="ghost"
            className="h-10 w-10 sm:h-8 sm:w-8 p-0 flex-shrink-0"
            onClick={onCancelEdit}
            title="Cancel"
          >
            ✕
          </Button>
        </>
      ) : (
        <>
          <span className="flex-1 text-sm break-words min-w-0">{item}</span>
          <Button
            size="sm"
            variant="ghost"
            className="h-10 w-10 sm:h-8 sm:w-8 p-0 flex-shrink-0"
            onClick={() => onStartEdit(index)}
            title="Edit"
          >
            <Edit2 className="h-4 w-4" />
          </Button>
          <Button
            size="sm"
            variant="ghost"
            className="h-10 w-10 sm:h-8 sm:w-8 p-0 flex-shrink-0 text-destructive hover:text-destructive"
            onClick={() => onRemove(index)}
            title="Remove"
          >
            <X className="h-4 w-4" />
          </Button>
        </>
      )}
    </div>
  );
}
